export const pin = {
    id: 'pin',
    width: 208,
    height: 232,
    d: 'M174.736 32.7109L174.736 32.7111C193.086 50.6941 203.567 74.9504 203.987 100.346C204.407 125.731 194.742 150.297 177.011 168.85L174.712 171.181L125.708 219.199C120.21 224.583 112.815 227.732 105.015 227.984C97.2365 228.235 89.6636 225.586 83.8198 220.593L82.2545 219.154L33.2602 171.146C14.5155 152.775 4 127.875 4 101.929C4 75.9825 14.5155 51.0825 33.2602 32.7109C52.0075 14.3366 77.4512 4 103.998 4C130.545 4 155.988 14.3366 174.736 32.7109Z',
};
